import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import classnames from 'classnames'
import { getIn } from 'formik'

import FieldLabelWrapper from '../../../../../../../../../../features/components/Form/FieldLabelWrapper'
import Field from '../../../../../../../../../../components/Form/Field'
import ErrorMessage from '../../../../../../../../../../components/Form/ErrorMessage'

import { fieldValueValidator } from '../ImdPercentageFields/helpers'

import { DISABILITY_PERCENTAGE, disabilityFields, STAKEHOLDERS_LIST } from '../../../../../../stakeholdersFields'

import useStyles from '../styles'

const DisabilityPercentageFields = ({ formik, index }) => {
  const { t } = useTranslation()

  const classes = useStyles()

  const { errors, touched } = formik
  const path = `${STAKEHOLDERS_LIST}[${index}][${DISABILITY_PERCENTAGE}]`
  const disabilityPercentageError = getIn(errors, path)
  const disabilityPercentageTouched = getIn(touched, path)

  return (
    <FieldLabelWrapper label={t('Disability')}>
      <div className={classes.row}>
        <FieldLabelWrapper
          label={t('No\n%')}
          className={classnames(classes.subLevelFieldWrapper, classes.ageFieldWrapper)}
          labelClassName={classes.subLevelLabel}
        >
          <Field
            className={classes.fieldInRow}
            formik={formik}
            name={`${path}[${disabilityFields.no}]`}
            symbol={'%'}
            symbolPosition="end"
            type={'number'}
            isAllowed={fieldValueValidator}
          />
        </FieldLabelWrapper>
        <FieldLabelWrapper
          label={t('Yes\n%')}
          className={classnames(classes.subLevelFieldWrapper, classes.ageFieldWrapper)}
          labelClassName={classes.subLevelLabel}
        >
          <Field
            className={classes.fieldInRow}
            formik={formik}
            name={`${path}[${disabilityFields.yes}]`}
            symbol={'%'}
            symbolPosition="end"
            type={'number'}
            isAllowed={fieldValueValidator}
          />
        </FieldLabelWrapper>
        <FieldLabelWrapper
          label={t('Unknown %')}
          className={classnames(classes.subLevelFieldWrapper, classes.ageFieldWrapper)}
          labelClassName={classes.subLevelLabel}
        >
          <Field
            className={classes.fieldInRow}
            formik={formik}
            name={`${path}[${disabilityFields.unknown}]`}
            symbol={'%'}
            symbolPosition="end"
            type={'number'}
            isAllowed={fieldValueValidator}
          />
        </FieldLabelWrapper>
      </div>
      {disabilityPercentageError && disabilityPercentageTouched && <ErrorMessage error={disabilityPercentageError} />}
    </FieldLabelWrapper>
  )
}

DisabilityPercentageFields.propTypes = {
  formik: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired
}

export default DisabilityPercentageFields
